'use client';

import Image from 'next/image';
import { useTranslation } from '@/hooks/useTranslations';
import './TrustedSection.scss';

export default function TrustedSection() {
  const { t } = useTranslation();

  return (
    <section
      id="about"
      className="trusted-section"
    >
      <div className="trusted-section__inner">
        <div className="trusted-section__stats">
          <div className="trusted-section__stat">
            <p className="trusted-section__stat-value">
              {t('trusted.stats.hireTime.value')}
            </p>
            <p className="trusted-section__stat-label">
              {t('trusted.stats.hireTime.label')}
            </p>
          </div>

          <div className="trusted-section__stat">
            <p className="trusted-section__stat-value">
              {t('trusted.stats.checks.value')}
            </p>
            <p className="trusted-section__stat-label">
              {t('trusted.stats.checks.label')}
            </p>
          </div>

          <div className="trusted-section__stat">
            <p className="trusted-section__stat-value">
              {t('trusted.stats.applyTime.value')}
            </p>
            <p className="trusted-section__stat-label">
              {t('trusted.stats.applyTime.label')}
            </p>
          </div>
        </div>

        <hr className="trusted-section__divider" />

        <div className="trusted-section__trusted">
          <h2 className="trusted-section__title">
            {t('trusted.title')}
          </h2>
          <p className="trusted-section__subtitle">{t('trusted.subtitle')}</p>

          <div className="trusted-section__logos">
            <Image
              src="/hardware-store.png"
              alt={t('trusted.logos.hardwareStore')}
              width={150}
              height={150}
              className="trusted-section__logo"
            />
            <Image
              src="/best-italy.png"
              alt={t('trusted.logos.bestOfItaly')}
              width={150}
              height={150}
              className="trusted-section__logo"
            />
            <Image
              src="/backyard.png"
              alt={t('trusted.logos.backyard')}
              width={150}
              height={150}
              className="trusted-section__logo"
            />
            <Image
              src="/norton-foods.png"
              alt={t('trusted.logos.nortonFoods')}
              width={150}
              height={150}
              className="trusted-section__logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
